import React from 'react';
import '../CSS/ComponentTitle.css'; // Import your CSS file for styling

interface ComponentTitleProps {
  title: string;
  className?: string; // Optional additional classes
  'data-testid'?: string; // For testing purposes
}

const ComponentTitle: React.FC<ComponentTitleProps> = ({
  title,
  className,
  'data-testid': dataTestId,
}) => {
  return (
    <div
      className={`component-title ${className || ''}`}
      data-testid={dataTestId}
    >
      {title}
    </div>
  );
};

export default ComponentTitle;
